import { tracked } from '@glimmer/tracking';
import CampaignModel from 'cio/models/campaign';
import WorkflowController from 'cio/pods/base/setup/workflow/actions/controller';
import { AddActionsPanelItemConfigs } from 'cio/utils/visual-workflow-builder/add-actions-panel';
import { task, timeout, waitForQueue } from 'ember-concurrency';
import { getOwner } from '@ember/application';

export default class VWBDemoController extends WorkflowController {
  queryParams = ['zoom', 'version'];

  selectedActionAbstract: any = null;
  highlightedNodeIds: string[] = [];
  campaign!: CampaignModel;

  @tracked zoom = 100;
  @tracked version: string | null = null;
  @tracked addPanelItemConfigs: AddActionsPanelItemConfigs = {};

  waitForLoadToFinish = task(async () => {
    // Under Hydra, the root element of the app is hidden (via "display: none")
    // until Hydra UI receives a callback from Journeys UI that it's initialized.
    // There are some timing issues where the internals of the Ember app are
    // starting to render (calling any did-render modifiers, constructors etc),
    // but Hydra UI hasn't yet removed the "display: none" style.
    // This is especially visible in the VWB demo routes, because there is no nested
    // route structure with loading templates, so there aren't any extra delays.
    // This adds an additional wait before rendering the VWB component
    let owner = getOwner(this) as any;
    let { rootElement } = owner;

    if (typeof rootElement === 'string') {
      rootElement = document.querySelector(rootElement);
    }

    let checkIsRootHidden = () => {
      if (rootElement == null) {
        return false;
      }

      let { display } = getComputedStyle(rootElement);
      return display === 'none';
    };
    let isRootHidden = checkIsRootHidden();

    while (isRootHidden) {
      await timeout(50);
      isRootHidden = checkIsRootHidden();
    }

    await waitForQueue('afterRender');
  });
}
